package com.rajen.angrejidictionary.data.remote.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Body for POST /api/v1/admin/notifications/broadcast.
 * `description` and `imageUrl` are optional — a title-only broadcast is valid.
 * `wordSlug` is also optional: when set, tapping the notification takes the
 * user straight to that word's detail screen instead of just opening the app.
 * If it doesn't match a real word, the backend returns a NOT_FOUND error.
 */
@Serializable
data class BroadcastNotificationRequest(
    val title: String,
    val description: String? = null,
    @SerialName("image_url") val imageUrl: String? = null,
    @SerialName("word_slug") val wordSlug: String? = null
)

/**
 * Result of a broadcast send. `prunedTokens` reflects dead FCM tokens
 * (uninstalled app, etc.) that the backend detected and removed from
 * storage as part of this call, so future broadcasts skip them.
 */
@Serializable
data class BroadcastNotificationResult(
    @SerialName("success_count") val successCount: Long,
    @SerialName("failure_count") val failureCount: Long,
    @SerialName("pruned_tokens") val prunedTokens: Long
)